var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Projects'),_c('Contact'),_c('Footer'),_c('Whatsapp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }